{
  "name": "web-app",
  "description": "3D Infrastructure for the Internet",
  "author": "colormass GmbH",
  "version": "7.3.0",
  "private": true,
  "license": "UNLICENSED",
  "scripts": {
    "platform:start:dev-local": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve platform --configuration=dev-local",
    "platform:start:qa": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve platform --configuration=qa",
    "platform:start:qa-remote": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve platform --configuration=qa-remote",
    "platform:start:qa2-remote": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve platform --configuration=qa2-remote",
    "platform:start:dev-remote": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve platform --configuration=dev-remote",
    "platform:start:dev3": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve platform --configuration=dev3",
    "platform:start:docker": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve platform --configuration=dev-local --host 0.0.0.0",
    "platform:build:dev-local": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev-local",
    "platform:build:qa-remote": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=qa-remote",
    "platform:build:dev-remote": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev-remote",
    "platform:build:dev": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev",
    "platform:build:dev2": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev2",
    "platform:build:dev3": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev3",
    "platform:build:dev4": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev4",
    "platform:build:dev5": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev5",
    "platform:build:qa": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=qa",
    "platform:build:qa2": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=qa2",
    "platform:build:prod": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform",
    "platform:test": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng test",
    "test:all": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng test --watch=false",
    "test:coverage": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng test --watch=false --coverage",
    "configurator:start:dev-local": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve configurator --configuration=dev-local --port 4300",
    "configurator:start:qa": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve configurator --configuration=qa --port 4300",
    "configurator:start:qa-remote": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve configurator --configuration=qa-remote --port 4300",
    "configurator:start:qa2-remote": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve configurator --configuration=qa2-remote --port 4300",
    "configurator:start:dev-remote": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve configurator --configuration=dev-remote --port 4300",
    "configurator:start:dev3": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve configurator --configuration=dev3 --port 4300",
    "configurator:build:dev-local": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=dev-local",
    "configurator:start:browserstack": "run-p gql:codegen:watch ng:serve:configurator:browserstack",
    "configurator:build:dev": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=dev",
    "configurator:build:dev2": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=dev2",
    "configurator:build:dev3": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=dev3",
    "configurator:build:dev4": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=dev4",
    "configurator:build:dev5": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=dev5",
    "configurator:build:qa": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=qa",
    "configurator:build:qa2": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=qa2",
    "configurator:build:prod": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build configurator --configuration=production",
    "ng:serve:configurator:browserstack": "cross-env NODE_OPTIONS=--max_old_space_size=16384 ng serve configurator --configuration=browserstack --port 4300 --allowed-hosts=true --host 0.0.0.0",
    "lib:inject": "bun run --cwd ../../shared/packages/browser-worker build && bun run --cwd ../../shared/packages/browser-worker inject && bun run --cwd ../../shared/packages/three-texture-streaming-browser inject",
    "gql:codegen": "graphql-codegen --config codegen.yml",
    "generate": "graphql-codegen --config codegen.yml",
    "gql:codegen:watch": "graphql-codegen --config codegen.yml --watch",
    "modernize:analyze": "bun run scripts/angular-modernize/index.ts analyze",
    "modernize:migrate": "bun run scripts/angular-modernize/index.ts migrate",
    "modernize:report": "bun run scripts/angular-modernize/index.ts report",
    "modernize:find-state": "bun run scripts/angular-modernize/index.ts find-template-state",
    "modernize:convert-state": "bun run scripts/angular-modernize/index.ts convert-template-state",
    "modernize:find-getters-methods": "bun run scripts/angular-modernize/index.ts find-getters-methods",
    "modernize:convert-getters-methods": "bun run scripts/angular-modernize/index.ts convert-getters-methods",
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "format": "prettier src --write",
    "all:build:dev-local": "run-s platform:build:dev-local configurator:build:dev-local",
    "all:build:dev": "run-s platform:build:dev configurator:build:dev",
    "all:build:dev2": "run-s platform:build:dev2 configurator:build:dev2",
    "all:build:dev3": "run-s platform:build:dev3 configurator:build:dev3",
    "all:build:dev4": "run-s platform:build:dev4 configurator:build:dev4",
    "all:build:dev5": "run-s platform:build:dev5 configurator:build:dev5",
    "all:build:qa": "run-s platform:build:qa configurator:build:qa",
    "all:build:qa2": "run-s platform:build:qa2 configurator:build:qa2",
    "all:build:prod": "run-s platform:build:prod configurator:build:prod",
    "kill:port:4200": "kill-port --port 4200",
    "check": "dpdm -T --no-tree --circular --no-warning --no-progress --skip-dynamic-imports circular --exit-code circular:1 src/platform.main.ts",
    "build": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build platform --configuration=dev-local",
    "build:all": "run-p platform:build:dev-local configurator:build:dev-local"
  },
  "dependencies": {
    "@angular/animations": "21.1.4",
    "@angular/cdk": "21.1.4",
    "@angular/common": "21.1.4",
    "@angular/compiler": "21.1.4",
    "@angular/core": "21.1.4",
    "@angular/elements": "21.1.4",
    "@angular/fire": "20.0.1",
    "@angular/forms": "21.1.4",
    "@angular/material": "21.1.4",
    "@angular/platform-browser": "21.1.4",
    "@angular/platform-browser-dynamic": "21.1.4",
    "@angular/platform-server": "21.1.4",
    "@angular/router": "21.1.4",
    "@apollo/client": "3.10.8",
    "@casl/ability": "6.7.1",
    "@casl/angular": "8.2.8",
    "@ngneat/content-loader": "7.0.0",
    "@ngneat/helipopper": "11.1.4",
    "@pdf-lib/fontkit": "1.1.1",
    "@popperjs/core": "^2.11.8",
    "@skilitics-public/two-fingers": "^2.1.0",
    "@stripe/stripe-js": "^5.6.0",
    "@tlaukkan/tsm": "0.8.5",
    "@types/bezier-js": "4.1.3",
    "apollo-angular": "8.0.0",
    "backoff-rxjs": "7.0.0",
    "bezier-js": "6.1.4",
    "change-case": "5.4.4",
    "chart.js": "4.4.4",
    "clipper-lib": "6.4.2",
    "core-js": "3.38.1",
    "d3": "7.9.0",
    "d3-dag": "1.1.0",
    "d3-zoom": "3.0.0",
    "date-fns": "4.1.0",
    "document-register-element": "1.14.10",
    "dompurify": "3.4.5",
    "fast-xml-parser": "4.5.0",
    "fbx-parser": "2.1.3",
    "filenamify": "6.0.0",
    "filesize": "9.0.11",
    "firebase": "11.10.0",
    "flatpickr": "4.6.13",
    "hammerjs": "2.0.8",
    "jssha": "3.3.1",
    "jszip": "3.10.1",
    "kill-port": "^2.0.1",
    "ndarray": "1.0.19",
    "pdf-lib": "1.17.1",
    "potpack": "2.0.0",
    "qrcode": "1.5.4",
    "rxfire": "6.1.0",
    "sha1-uint8array": "0.10.7",
    "stream": "0.0.3",
    "svd-js": "1.1.1",
    "symbol-observable": "4.0.0",
    "three": "0.184.0",
    "three-mesh-bvh": "0.8.3",
    "tippy.js": "6.3.7",
    "tree-kill": "1.2.2",
    "tslib": "2.7.0",
    "upng-js": "2.1.0",
    "utif2": "4.1.0",
    "uuid": "10.0.0",
    "xlsx": "0.18.5",
    "xml-writer": "1.7.0",
    "zod": "3.25.67",
    "zod-key-parser": "1.5.5",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.1.4",
    "@angular/build": "21.1.4",
    "@angular/cli": "21.1.4",
    "@angular/compiler-cli": "21.1.4",
    "@graphql-codegen/introspection": "4.0.3",
    "@graphql-codegen/near-operation-file-preset": "3.0.0",
    "@graphql-codegen/plugin-helpers": "5.1.0",
    "@graphql-codegen/typed-document-node": "5.0.12",
    "@graphql-codegen/typescript-apollo-angular": "4.0.0",
    "@graphql-codegen/typescript-generic-sdk": "4.0.1",
    "@parcel/watcher": "2.4.1",
    "@types/chart.js": "2.9.41",
    "@types/d3": "7.4.3",
    "@types/dompurify": "3.2.0",
    "@types/hammerjs": "2.0.45",
    "@types/ndarray": "1.0.14",
    "@types/qrcode": "1.5.5",
    "@types/three": "0.184.0",
    "@types/uuid": "10.0.0",
    "@vitest/coverage-v8": "4.0.18",
    "@webgpu/types": "0.1.69",
    "concat": "1.0.3",
    "copyfiles": "2.4.1",
    "cross-env": "10.1.0",
    "dotenv": "16.4.5",
    "jsdom": "28.1.0",
    "npm-run-all": "4.1.5",
    "patch-package": "8.0.0",
    "sass": "1.77.8",
    "ts-morph": "27.0.2",
    "vitest": "4.0.18"
  },
  "workspaces": [
    "../../backend/",
    "../../shared/packages/*"
  ],
  "optionalDependencies": {
    "@cm/auth": "workspace:*",
    "@cm/browser-log": "workspace:*",
    "@cm/browser-utils": "workspace:*",
    "@cm/image-processing-nodes": "workspace:*",
    "@cm/graph-v2-final": "workspace:*",
    "@cm/graph-v3": "workspace:*",
    "@cm/hal": "workspace:*",
    "@cm/image-processing": "workspace:*",
    "@cm/job-nodes": "workspace:*",
    "@cm/log": "workspace:*",
    "@cm/material-maps-exporter": "workspace:*",
    "@cm/material-outputs-filenames": "workspace:*",
    "@cm/material-outputs-publishing": "workspace:*",
    "@cm/material-nodes": "workspace:*",
    "@cm/math": "workspace:*",
    "@cm/mattress-nodes": "workspace:*",
    "@cm/pricing": "workspace:*",
    "@cm/render-nodes": "workspace:*",
    "@cm/template-nodes": "workspace:*",
    "@cm/utils": "workspace:*",
    "@cm/wasm": "workspace:*",
    "@cm/web-assembly": "workspace:*",
    "@cm/webgl2": "workspace:*",
    "@cm/three-texture-streaming": "workspace:*",
    "@cm/three-texture-streaming-browser": "workspace:*"
  }
}
